import { render } from "./AttachFile.vue?vue&type=template&id=793eb7d2"
import script from "./AttachFile.vue?vue&type=script&lang=js"
export * from "./AttachFile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__